import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { ModalLoading } from "../../../../../../common/components/modal_loading";

import FormContainer from "../../../../../../common/components/form_container";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DefaultInput from "../../../../../../common/components/default_input";

/**
 * CopyCargoModal
 */

type Props = {
  open: boolean,
  saving: boolean,
  onSubmit: (descricao: string) => void,
  onClose: (idCargo: number | null, openState: boolean) => void,
};

export const CopyCargoModal = ({
  open,
  saving,
  onSubmit,
  onClose,
}: Props) => {
  const [descricao, setDescricao] = useState('');

  useEffect(() => {
    if (open) {
      setDescricao('');
    }
  }, [open]);

  const handleClose = useCallback(() => {
    if (!saving) onClose(null, false);
  }, [saving, onClose]);

  return (
    <Dialog
      open={open}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "45rem",
          },
        },
      }}>
      <DialogTitle>
        Copiar Motivo Demissão
      </DialogTitle>

      <DialogContent>
        <ModalLoading loading={saving}>
          <FormContainer title={"Informações"} arrangement="fullRow">
            <>
              <DefaultInput
                name='descricao'
                label='Nome'
                value={descricao ?? null}
                onChangeValue={(s) => setDescricao(s)} />
            </>
          </FormContainer>
        </ModalLoading>
      </DialogContent>

      <DialogActions>
        <div className="w-full h-full items-center justify-end flex p-4 gap-4">
          <div className="flex flex-row gap-2">
            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
              <h1
                className="text-sm text-black dark:text-white"
                onClick={handleClose}>
                Cancelar
              </h1>
            </div>

            <div className="w-[120px]">
              {saving ? (
                <PrimaryButton
                  buttonColor="primary-green">
                  Salvando...
                </PrimaryButton>
              ) : (
                <PrimaryButton
                  buttonColor="primary-green"
                  onClick={() => { if (!saving) onSubmit(descricao); }}>
                  Salvar
                </PrimaryButton>
              )}
            </div>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
}